module.exports = __webpack_public_path__ + "static/media/google_black.a8ba892e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Badges/medias/google_black.svg
// module id = 159
// module chunks = 0